import { render, staticRenderFns } from "./WhitelabelView.vue?vue&type=template&id=5784aa65"
import script from "./WhitelabelView.vue?vue&type=script&lang=js"
export * from "./WhitelabelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports